module.exports = __webpack_public_path__ + "img/picture.a762b7a1.svg";